
<div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
        <th scope="col">Kundenr</th>
        <th scope="col">Navn</th>
        <th *ngIf="hasSag" scope="col">Sag</th>
        <th scope="col">Regnskabsår</th>
        <th scope="col">Godkendt</th>
        <th scope="col">Init</th>
        <th scope="col">Set</th>
        </thead>
        <tbody>
        <tr *ngFor="let notifikation of v2Notifikationer$ | async; trackBy: trackById"
            class="clickable"
            (click)="navigateToAction(notifikation)">
            <td>{{notifikation.metadata.glkundenr}}</td>
            <td>{{notifikation.metadata.navn}}</td>
            <td *ngIf="hasSag">{{notifikation.metadata.sagBeskrivelse}}</td>
            <td>{{notifikation.metadata.regnskabsaar}}</td>
            <td>{{notifikation.oprettetTid | date:'dd-MM-yyyy'}}</td>
            <td>{{notifikation.fraInitialer}}</td>
            <td><button class="btn btn-sm btn-primary" (click)="onSeen($event, notifikation.id)">Set</button></td>
        </tr>
        </tbody>
    </table>
</div>
